// these match backend
// update: we have SplitLevelEnum now, they match those
export enum ScopeEnum {
    STORE = 'STORE',
    PARTNER = 'PARTNER',
    CLUSTER = 'CLUSTER',
    GLOBAL = 'GLOBAL',
}
